import { isEmpty } from '../../../utility/validation';
import { FIELD_TYPES } from '../../../constants/fieldTypes';

const AUTHENTICATION_FIELDS = [
  {
    name: 'code',
    type: FIELD_TYPES.TEXT,
    label: 'code',
    required: true,
    validators: [
      {
        type: 'required',
        validator: isEmpty,
      },
    ],
  },
];

export default AUTHENTICATION_FIELDS;
